<template>
  <v-card
    class="mx-auto"
    outlined
  >
    <form>
      <v-row
        no-gutters
        class="px-4"
      >
        <v-col
          cols="12"
          class="px-3"
          :sm="12"
          :md="6"
        >
          <v-text-field
            v-model="client.email"
            label="Почта"
            :error-messages="emailErrors"
            required
            @input="$v.client.email.$touch()"
            @blur="$v.client.email.$touch()"
          />
        </v-col>
        <v-col
          cols="12"
          class="px-3"
          :sm="12"
          :md="6"
        >
          <v-text-field
            v-model="client.firstName"
            label="Имя"
            required
          />
        </v-col>
        <v-col
          cols="12"
          class="px-3"
          :sm="12"
          :md="6"
        >
          <v-text-field
            v-model="client.lastName"
            label="Фамилия"
            required
          />
        </v-col>
        <v-col
          cols="12"
          class="px-3"
          :sm="12"
          :md="6"
        >
          <v-text-field
            v-model="client.middleName"
            label="Отчество"
            required
          />
        </v-col>
        <v-col
          cols="12"
          class="px-3"
          :sm="12"
          :md="6"
        >
          <v-text-field
            v-model="client.profession"
            label="Должность"
            required
          />
        </v-col>
        <v-col
          cols="12"
          class="px-3"
          :sm="12"
          :md="6"
        >
          <v-text-field
            v-model="client.telephone"
            label="Телефон"
            required
          />
        </v-col>
        <v-col
          cols="12"
          class="px-3"
          :sm="12"
          :md="6"
        >
          <v-text-field
            v-model="client.dateOfBorn"
            label="Дата рождения"
            type="date"
            required
          />
        </v-col>
      </v-row>

      <v-btn
        text
        outlined
        rounded
        color="success"
        class="mr-4"
        @click="submit"
      >
        Сохранить
      </v-btn>
    </form>
  </v-card>
</template>

<script>
import { validationMixin } from 'vuelidate'
import { required, email } from 'vuelidate/lib/validators'
import DictionaryMixin from '@/mixins/dictionaryMixin'
import OrganizationMixin from '@/mixins/organizationMixin.vue'

export default {
  name: 'ClientFrom',
  mixins: [validationMixin, DictionaryMixin, OrganizationMixin],
  validations: {
    client: {
      email: { required, email }
    }
  },
  props: {
    personaInformation: {
      type: Object
    }
  },
  data: () => ({
    dictionaries: { legalFormTypeList: [] },
    client: {
      'organization': {
        'id': null
      },
      'email': null,
      'firstName': null,
      'dateOfBorn': null,
      'lastName': null,
      'middleName': null,
      'profession': null,
      'telephone': null
    }
  }),
  computed: {
    emailErrors () {
      const errors = []
      if (!this.$v.client.email.$dirty) return errors
      !this.$v.client.email && errors.push('поле обязательно для заполнения.')
      !this.$v.client.email.email && errors.push('Не валидня почту')
      return errors
    },
  },

  created () {
    this.client.organization.id = this.$route.params.organizationId
  },
  methods: {
    submit () {
      this.$v.$touch()
      this.inviteAdmin(this.client)
    },
    clear () {
      this.$v.$reset()
      this.client = null
    },
  }
}
</script>
<style lang="scss" scoped>
    .office-item {
        cursor: pointer;
    }
</style>

